(function (window, document) {
  "use strict";

  function onReady(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback);
      return;
    }

    callback();
  }

  onReady(function () {
    var manager = window.AiPlacesConsent;
    var root = document.querySelector("[data-cookie-consent]");

    if (!manager || !root) {
      return;
    }

    var settings = root.querySelector("[data-cookie-consent-settings]");
    var status = root.querySelector("[data-cookie-consent-status]");
    var toggles = Array.prototype.slice.call(root.querySelectorAll("[data-consent-category]"));
    var manageButtons = Array.prototype.slice.call(document.querySelectorAll("[data-cookie-consent-manage]"));
    var openButtons = Array.prototype.slice.call(document.querySelectorAll("[data-cookie-consent-open]"));

    function hasChoice() {
      return manager.getState() !== null;
    }

    function setStatus(message) {
      if (status) {
        status.textContent = message;
      }
    }

    function setExpanded(expanded) {
      root.classList.toggle("is-expanded", expanded);
      root.setAttribute("data-view", expanded ? "settings" : "summary");

      if (settings) {
        settings.hidden = !expanded;
      }
    }

    function syncToggles() {
      var preferences = manager.getPreferences();

      toggles.forEach(function (toggle) {
        var category = toggle.getAttribute("data-consent-category");
        toggle.checked = Boolean(preferences[category]);
      });
    }

    function collectPreferences() {
      var preferences = {
        necessary: true
      };

      toggles.forEach(function (toggle) {
        var category = toggle.getAttribute("data-consent-category");
        preferences[category] = Boolean(toggle.checked);
      });

      return preferences;
    }

    function setManageButtonVisibility(visible) {
      manageButtons.forEach(function (button) {
        button.hidden = !visible;
      });
    }

    function show(settingsOpen) {
      syncToggles();
      root.hidden = false;
      root.classList.add("is-visible");
      root.setAttribute("aria-hidden", "false");
      setExpanded(Boolean(settingsOpen));
      setStatus(hasChoice() ? "ניתן לשנות את ההעדפות בכל רגע." : "ממתין לבחירת העדפות.");
      setManageButtonVisibility(false);
    }

    function hide() {
      root.classList.remove("is-visible");
      root.setAttribute("aria-hidden", "true");
      root.hidden = true;
      setManageButtonVisibility(hasChoice());
    }

    function savePreferences(preferences, source) {
      manager.save(preferences, source);
      syncToggles();
      setStatus("הבחירה נשמרה.");
      hide();
    }

    root.addEventListener("click", function (event) {
      var target = event.target;
      var action = target && typeof target.closest === "function"
        ? target.closest("[data-cookie-consent-action]")
        : null;

      if (!action || !root.contains(action)) {
        return;
      }

      event.preventDefault();

      switch (action.getAttribute("data-cookie-consent-action")) {
        case "accept":
          savePreferences({
            analytics: true,
            marketing: true,
            preferences: true
          }, "accept_all");
          break;

        case "reject":
          savePreferences({
            analytics: false,
            marketing: false,
            preferences: false
          }, "reject_optional");
          break;

        case "customize":
          setExpanded(true);
          break;

        case "summary":
          setExpanded(false);
          break;

        case "save":
          savePreferences(collectPreferences(), "customize");
          break;

        default:
          break;
      }
    });

    openButtons.forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        show(true);
      });
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && !root.hidden && hasChoice()) {
        hide();
      }
    });

    manager.onChange(function () {
      syncToggles();
      setManageButtonVisibility(hasChoice() && root.hidden);
    });

    if (hasChoice()) {
      hide();
      return;
    }

    show(false);
  });
})(window, document);
